// What a trip card says about a trip, worked out from the post's trip record. Apart from the card so it can be tested on its own.

const MS_PER_DAY = 24 * 60 * 60 * 1000;

const toDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

/** "5D 4N" — days counted inclusive of both travel days, nights one fewer; null when either date is missing. */
export const durationChip = (trip) => {
  const start = toDate(trip?.startDate);
  const end = toDate(trip?.endDate);
  if (!start || !end || end < start) return null;
  const days = Math.round((end - start) / MS_PER_DAY) + 1;
  const nights = days - 1;
  return nights > 0 ? `${days}D ${nights}N` : `${days}D`;
};

/** "Apr 2025" for the trip's first day; null when it has none. */
export const monthYear = (trip) => {
  const start = toDate(trip?.startDate);
  return start ? start.toLocaleDateString("en-GB", { month: "short", year: "numeric" }) : null;
};

/** "₹8,500" in the trip's own currency (rupees when it names none); null when no budget was given. */
export const budgetLabel = (trip) => {
  if (typeof trip?.budget !== "number" || !Number.isFinite(trip.budget) || trip.budget <= 0) return null;
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: trip.currency || "INR",
      maximumFractionDigits: 0,
    }).format(trip.budget);
  } catch {
    return `₹${Math.round(trip.budget).toLocaleString("en-IN")}`;
  }
};
